import React, {useEffect, useState} from 'react';
import JobMetricOrganizationTable
    from "../../../components/UI/table/prodaction/jobmetricorganization/JobMetricOrganizationTable";
import JobMetricOrganizationService from "../../../API/orders/job/JobMetricOrganizationService";
import {useLocation} from "react-router-dom";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import JobMetricAdminPackingService from "../../../API/orders/job/Admin/JobMetricAdminPackingService";
import JobMetricAdminMillingService from "../../../API/orders/job/Admin/JobMetricAdminMillingService";
import JobMetricAdminDrillingService from "../../../API/orders/job/Admin/JobMetricAdminDrillingService";
import JobMetricAdminEdgeService from "../../../API/orders/job/Admin/JobMetricAdminEdgeService";
import JobMetricAdminCuttingService from "../../../API/orders/job/Admin/JobMetricAdminCuttingService";
import {calcFilterData} from "../../../utils/common/calcFilterData";
import {JobMetricOrganizationFilterData} from "../../../data/FilterTables/JobMetricOrganizationFilterData";
import OrderUtil from "../../../utils/orders/OrderUtil";
import {orderJobType} from "../../../data/OrderJobType";

const JobMetricOrganization = ({admin, itemId, handleModalAlert, settings}) => {
    const pathname = useLocation().pathname
    const [change, setChange] = useState(false);
    const [dataJobMetricOrganization, setDataJobMetricOrganization] = useState([]);
    const [rowSelection, setRowSelection] = useState([]);
    const [rowIndexSelection, setRowIndexSelection] = useState([])
    const [selectedIds, setSelectedIds] = useState([]);
    const profile = JSON.parse(localStorage.getItem("profile"))
    const [baseCurrency, setBaseCurrency] = useState(profile?.baseCurAbbreviation);
    const [alternativeCurrency, setAlternativeCurrency] = useState(profile?.alternativeCurAbbreviation);
    const [filteredData, setFilteredData] = useState([])
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const api = itemId === "listJobPacking" ? JobMetricAdminPackingService :
        itemId === "listJobMilling" ? JobMetricAdminMillingService
            : itemId === "listJobEdge" ? JobMetricAdminEdgeService
                : itemId === "listJobDrilling" ? JobMetricAdminDrillingService
                    : itemId === "listJobCutting" ? JobMetricAdminCuttingService
                        : JobMetricOrganizationService

    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, JobMetricOrganizationFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [JobMetricOrganizationFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(`${pathname}+${itemId}`, "searchQuery", searchQuery)
            }
        }
    }
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}+${itemId}`]?.pageSize
        const searchQuery = pagesData[`${pathname}+${itemId}`]?.searchQuery

        return {searchQuery, pageSize}
    }

    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        const method = itemId === "listJob" ? api.getAllJobMetricOrganizationForSettings : api.get
        method().then(function (response) {
            const data = response.data
            setDataJobMetricOrganization(data);
            handleSearchQuery(searchQuery, data, pageSize)
            setTypeList(OrderUtil.getListFieldByEnum(data, 'orderJobType', orderJobType));
        })
            .catch(function (error) {
                handleModalAlert(error);
            });

    }, [itemId]);

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}+${itemId}`, "pageSize", nextState.pageSize)
        }
    }

    return (

        <JobMetricOrganizationTable
            admin={admin}
            api={api}
            itemId={itemId}
            data={dataJobMetricOrganization}
            setData={setDataJobMetricOrganization}
            change={change}
            setChange={setChange}
            rowSelection={rowSelection}
            setRowSelection={setRowSelection}
            rowIndexSelection={rowIndexSelection}
            setRowIndexSelection={setRowIndexSelection}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            isChooseSignJob={false}
            baseCurrency={baseCurrency}
            alternativeCurrency={alternativeCurrency}
            tableOptions={tableOptions}
            tableOptionsHandle={tableOptionsHandle}
            columnAdded={true}
            isUnit={admin}
            handleModalAlert={handleModalAlert}
            settings={settings}
            added={!admin}
            globalFilter={globalFilter}
            handleSearchQuery={handleSearchQuery}
            filteredData={filteredData}
            columnsFilter={columnsFilter}
            typeList={typeList}
        />

    );
};

export default JobMetricOrganization;